import React, { ComponentType, useEffect, useState } from "react";
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";
import LoginScreen from "./screen/LoginScreen";
import { ActivityIndicator } from "react-native";
import * as firebase from "firebase/app";
import EditOnboardingQuestion from "./screen/EditOnboardingQuestion";
import { CenterBox } from "./components/Container";
import EditProductQuestionary from "./screen/EditProductQuestionary";
import EditTOS from "./screen/EditTOS";
import EditPrivacyPolicy from "./screen/EditPrivacyPolicy";
import TOSPage from "./screen/TOSPage";
import PrivacyPolicyPage from "./screen/PrivacyPolicyPage";
import ExportCSV from "./screen/ExportCSV";

const protect = (component: ComponentType<any>) => (props: any) => {
  const [isAdmin, setIsAdmin] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    return firebase.auth().onAuthStateChanged(async u => {
      if (u == null) {
        setIsAdmin(false);
        return;
      }
      const result = await u.getIdTokenResult();
      setIsAdmin(Boolean(result.claims.isAdmin));
    });
  }, []);
  if (isAdmin === undefined) {
    return (
      <CenterBox>
        <ActivityIndicator />
      </CenterBox>
    );
  }
  if (!isAdmin) {
    return <Redirect to="/login" />;
  }
  return React.createElement(component, props);
};

const AppRouter = () => (
  <Router>
    <>
      <Route
        path="/"
        exact={true}
        component={protect(EditOnboardingQuestion)}
      />
      <Route path="/editTOS" component={protect(EditTOS)} />
      <Route path="/editPrivacyPolicy" component={protect(EditPrivacyPolicy)} />
      <Route path="/export/:collection" component={protect(ExportCSV)} />
      <Route
        path="/onboardingQuestions"
        component={protect(EditOnboardingQuestion)}
      />
      <Route path="/vendor/:type" component={protect(EditProductQuestionary)} />
      <Route path="/login" component={LoginScreen} />
      <Route path="/tos" component={TOSPage} />
      <Route path="/privacyPolicy" component={PrivacyPolicyPage} />
    </>
  </Router>
);

export default AppRouter;
